export const env = process.env.ENV ? process.env.ENV : 'prod';
// logger.log(process.env.ENV);
// logger.log(process.env);

// Base urls
const BaseURLs = {
  rahul: 'https://rahulmrcabe.thecarebox.in',
  dev: 'https://snehmrcabe.thecarebox.in',
  stage: 'https://stageapi.uprohq.app',
  sneh: 'https://snehmrcabe.thecarebox.in',
  basil: 'https://basilmrcabe.thecarebox.in',
  prod: 'https://api.uprohq.app',
  shubhampalmonk: 'https://shubhampalmonkmrcabe.thecarebox.in'
};

// const amplitudeKey = {
//   dev: "d5a4a1b2a435318b265e3bc7f1b0ea27",
//   stage: "d5a4a1b2a435318b265e3bc7f1b0ea27",
//   prod: "6a530290593349167f3d33db403f57b1",
// };

// const amplitudeInstanceName = {
//   dev: "devAppFE",
//   stage: "stageAppFE",
//   prod: "prodAppFE",
// };

const bugsnagKey = {
  prod: 'd4542c16d530fa1114d896371c046ea6',
};

export function getBugsnagKey() {
  return bugsnagKey[env];
}

export const BaseURL = BaseURLs[env];

// export function getAmplitudeKey() {
//   return amplitudeKey[env];
// }

// export function getAmplitudeInstanceName() {
//   return amplitudeInstanceName[env];
// }
